'use client';

import type { useTranslations } from 'next-intl';
import { ProductElementLibrary } from '@/app/components/icons/ProductElementLibrary';
import { ProductElementLine } from '@/app/components/icons/ProductElementLine';
import { ProductLineElement } from '@/app/components/icons/ProductLineElement';
import { SITE } from '@/app/constants';
import { ProductElementFore } from './_components/ProductElementFore';
import { VIDEO_RESOURCES_CLAW, VIDEO_RESOURCES_IMG, VIDEO_RESOURCES_REFERENCE } from './constants';

/**
 * 获取Vidu能力详情数据
 * @param t 翻译函数
 * @returns 能力详情数据数组
 */
export const getViduAbilityDetail = (t: ReturnType<typeof useTranslations>) => {
  return [
    {
      title: t('claw.title'),
      key: 'claw',
      description: t('claw.description'),
      button: t('claw.button'),
      buttonRedirectUrl: SITE === 'china' ? 'https://www.vidu.cn/claw' : 'https://www.vidu.com/claw',
      videoResource: VIDEO_RESOURCES_CLAW,
    },
    {
      title: t('reference.title'),
      key: 'reference',
      description: t('reference.description'),
      button: t('reference.button'),
      videoResource: VIDEO_RESOURCES_REFERENCE,
      detail: [
        {
          id: 'multielementconsistency',
          title: t('reference.multiReference'),
          description: t('reference.mltReDesc'),
          icon: (
            <ProductElementLibrary className="size-10 md:h-[40px] md:w-[40px] md:rounded-full md:bg-system-white08 md:p-[7.5px]" />
          ),
          button: t('reference.button2'),
          backgroundImage:
            SITE === 'china'
              ? 'https://image01.vidu.zone/vidu/media-asset/viduAbilityReStart-01e52c27.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/viduAbilityReStart-01e52c27.webp',
          redirectUrl: '/create/character2video',
        },
        {
          id: 'myreferences',
          title: t('reference.themeLibrary'),
          description: t('reference.themeLibraryDesc'),
          icon: (
            <ProductLineElement className="size-10 py-[2px] md:h-[40px] md:w-[40px] md:rounded-full md:bg-system-white08 md:p-[7.5px]" />
          ),
          button: t('reference.button2'),
          backgroundImage:
            SITE === 'china'
              ? 'https://image01.vidu.zone/vidu/media-asset/viduAbilityReEnd-254ebd10.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/viduAbilityReEnd-254ebd10.webp',
          redirectUrl: '/create/character2video',
        },
      ],
    },
    {
      title: t('image.title'),
      key: 'image',
      description: t('image.description'),
      button: t('image.button'),
      videoResource: VIDEO_RESOURCES_IMG,
      detail: [
        {
          id: 'firstlastframes',
          title: t('image.setFirst'),
          description: t('image.setFirstReDesc'),
          button: t('image.button'),
          icon: (
            <ProductElementFore className="size-10 md:h-[40px] md:w-[40px] md:rounded-full md:bg-system-white08 md:p-[7.5px]" />
          ),
          backgroundImage:
            SITE === 'china'
              ? 'https://image01.vidu.zone/vidu/media-asset/viduAbilityStart-0779cc5f.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/viduAbilityStart-0779cc5f.webp',
          redirectUrl: '/create/img2video',
        },
        {
          id: 'animearttovideo',
          title: t('image.animeArt'),
          description: t('image.animeArtDesc'),
          button: t('image.button'),
          icon: (
            <ProductElementLine className="size-10 md:h-[40px] md:w-[40px] md:rounded-full md:bg-system-white08 md:p-[7.5px]" />
          ),
          backgroundImage:
            SITE === 'china'
              ? 'https://image01.vidu.zone/vidu/media-asset/viduAbilityEnd-0a6abe66.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/viduAbilityEnd-0a6abe66.webp',
          redirectUrl: '/create/img2video',
        },
      ],
    },
  ];
};
